// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_ADD_EXPERIENCE_TITLE = "P\u0159idej svou zku\u0161enost";
export const ARTICLE_EXPERIENCE_SEND = "Ode\u0161li";
export const SEO_TITLE_WIKI_ARTICLE_ADD_EXPERIENCE = "P\u0159idej svou zku\u0161enost";
export const WIKI_EXP_DRAFT_SAVE_AS_DRAFT = "Ulo\u017e jako draft";
